<template lang="pug">
.container
  h1 FORECAST
  .inputrow

    labeled(caption="Anzahl Tickets")
      select(v-model="ticketCount")
        option(v-for="c in ticketCounts", :value="c") {{ c }}
    labeled(caption="Anzahl Tests")
      select(v-model="testDrawCount")
        option(v-for="c in testSizes", :value="c") {{ c }}
    labeled(caption="ab Datum")
      select(v-model="date")
        option(v-for="d in dates", :value="d") {{ d }}
  .inputrow

    labeled(caption="Gewichtung")
      select(v-model="strategy")
        option(v-for="d in strategies", :value="d") {{ d }}

    button3d(style="margin:1vw;", @click="runForecast()")
      icon(name="play")
    button3d(style="margin:1vw;")
      icon(name="euro")
    button3d(style="margin:1vw;")
      icon(name="lotto")
  .wins(v-if="forecast && forecast.data")
    .header
      .date Datum
      .brutto Brutto
      .costs Kosten
      .netto Netto
    .item(
      v-for="(w, ix) in forecast.data",
      style="overflow: auto",
      :class="{ odd: ix % 2 > 0 }"
    )
      .date {{ new Date(w.draw.drawDate).toLocaleDateString(undefined, dateOpts) }}
      .brutto {{ w.wins.allWins.toFixed(2) }} €
      .costs {{ w.wins.costs.toFixed(2) }} €
      .netto {{ w.wins.netto.toFixed(2) }} €
    .sum
      .date Gesamt
      .brutto {{ win.brutto.toFixed(2) }} €
      .costs {{ win.costs.toFixed(2) }} €
      .netto {{ win.netto.toFixed(2) }} €
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Icon from "@/components/Icon.vue";
import Button3d from "@/components/Button3d.vue";
import LottoGrid from "@/components/LottoGrid.vue";
import Labeled from "@/components/Labeled.vue";

export default {
  components: { Icon, Button3d, LottoGrid, Labeled },
  data() {
    return {
      dates: [],
      ticketCounts: [10, 20, 50, 100, 150, 180, 200, 220, 250, 500, 1000],
      strategies: [
        "keine",
        "frequency",
        "timeDecay",
        "hybrid",
        "evenOddBalance",
        "sumRange",
        "pairBoost",
        "hotCold",
      ],
      strategy: "frequency",
      testSizes: [1,2,4,8,26,52,104],
      dateOpts: {
        weekday: "short",
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
      },
      date: new Date("2024-1-1"),
      ticketCount: 200,
      testDrawCount: 1,
      maxDate: 0,
    };
  },
  computed: {
    ...mapGetters({
      forecast: "lotto/forecast",
    }),
    win() {
      let brutto = 0;
      let costs = 0;
      let netto = 0;
      this.forecast.data.forEach((d) => {
        brutto += d.wins.allWins;
        costs += d.wins.costs;
        netto += d.wins.netto;
      });
      return { brutto, costs, netto };
    },
  },
  async mounted() {
    const t = new Date(new Date().getTime() - 90 * 24 * 60 * 60 * 1000);
    t.setDate(1);
    this.maxDate = t.toLocaleDateString("fr-ca");
    let date = t;
    this.date = this.maxDate;
    for (let i = 0; i < 24; i++) {
      this.dates.push(date.toLocaleDateString("fr-ca"));
      let m = date.getMonth() - 1;
      let y = date.getFullYear();
      if (m < 0) {
        m = 11;
        y = y - 1;
      }
      date = new Date(y, m, 1);
    }
  },
  methods: {
    ...mapActions({
      getForecast: "lotto/get_forecast",
    }),
    runForecast() {
      const cfg = {
        date: this.date,
        tickets: this.ticketCount,
        draws: this.testDrawCount,
        strategy: this.strategy
      };
      this.getForecast(cfg);
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  color: #000;
  font-size: 3vw;
  display: flex;
  flex-flow: column;
  align-items: stretch;
}
.inputrow {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.wins {
  overflow: auto;
  display: grid;
  gap: 0;
  font-size: 2.8vw;
  grid-template-columns: 2.1fr 2fr 2fr 2fr;
  margin: 4vw;
}

.date {
  text-align: left;
}

.brutto {
  text-align: right;
  padding: 0.2vw 2vw;
}
.costs {
  text-align: right;
  padding: 0.2vw 2vw;
}
.netto {
  text-align: right;
  padding: 0.2vw 2vw;
}

.item {
  display: contents;
}

.item div {
  padding: 0.4vw 1vw;
}
.header {
  display: contents;
}

.header div {
  // grid-area: header;
  background: #ddd;
  padding: 0.2vw 2vw;
  font-weight: bold;
}

.sum {
  display: contents;
}

.odd .date,
.odd .brutto,
.odd .netto,
.odd .costs {
  background: #e0e8e0;
}

.sum div {
  color: #048;
  font-weight: bold;
  border-top: 1px solid silver;
  padding: 0.2vw 2vw;
  padding-top: 1vw;
}
</style>